import { useEffect } from "react";

const PagePreloader = ({ time }) => {
  // after the page is loaded, remove the preloader
  useEffect(() => {
    // after 3 seconds, remove the preloader
    // const timer = setTimeout(() => {
    setTimeout(() => {
      const loaderWrapper = document.querySelector(".loader-wrapper");
      if (loaderWrapper) {
        loaderWrapper.style.display = "none"; // Hide the preloader
      }
    }, time || 1000); // Adjust the time as needed
  }, [time]);

  return (
    <div className="loader-wrapper">
      <div className="loader"></div>
      <div className="loader-section section-left"></div>
      <div className="loader-section section-right"></div>
    </div>
  );
};

export default PagePreloader;
